import { brandingVariables } from 'smartsuite-ui';
import { getFormattedValue } from '../../../dashboardUtils';

export const indicatorStatuses = {
    bad: 'bad',
    good: 'good',
    neutral: 'neutral',
};

function getGoodColor(colorWhenGood) {
    return colorWhenGood
        ? brandingVariables.success
        : brandingVariables.accent4;
}

function getBadColor(colorWhenBad) {
    return colorWhenBad ? brandingVariables.error : brandingVariables.accent4;
}

export function getIndicatorColorFromStatus(
    indicatorStatus,
    colorWhenBad,
    colorWhenGood
) {
    if (indicatorStatus === indicatorStatuses.good) {
        return getGoodColor(colorWhenGood);
    }

    if (indicatorStatus === indicatorStatuses.bad) {
        return getBadColor(colorWhenBad);
    }

    return brandingVariables.accent4;
}

function isGoodBasedOnThreshold(value, threshold, expectValueOverThreshold) {
    return expectValueOverThreshold ? value > threshold : value < threshold;
}

// eslint-disable-next-line complexity
export function getIndicatorStatus(value, threshold, expectValueOverThreshold) {
    if (value === null || value === undefined || value === threshold) {
        return indicatorStatuses.neutral;
    }

    return isGoodBasedOnThreshold(value, threshold, expectValueOverThreshold)
        ? indicatorStatuses.good
        : indicatorStatuses.bad;
}

export function valueWithSign(value, suffix, formatValue) {
    const formattedValue = getFormattedValue(value, suffix, formatValue);

    return value > 0 ? `+${formattedValue}` : formattedValue;
}
